<section>

    <app-navbar></app-navbar>

    <body>
        <div class="container pt-4">
            <div class="row">
                <!-- <button type="button" class="btn btn-danger btn-lg btn-block" (click)="signInWithGoogle()">Iniciar con Google</button> -->
                <div class="col-sm">
                    <button type="button" class="btn btn-primary btn-lg btn-block" (click)="signInWithFB()">Iniciar con Facebook</button>
                </div>
               <div class="col-sm">
                <button type="button" class="btn btn-success btn-lg btn-block" (click)="signInWithMail()">Iniciar con Mail</button>
               </div>
               <div class="col-sm">
                <button type="button" class="btn btn-danger btn-lg btn-block" (click)="signInWithGoogle()">Iniciar con Google</button>
               </div>
            </div>
        </div>

    </body>

    <app-foot></app-foot>

    

</section>